"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../context");

var _utils = require("../utils");

var _propTypes = require("../prop-types");

var _constants = require("./constants");

var _TextCSS = require("./TextCSS");

var TextWithoutDocs = (0, _context.styledWithTheme)('div', {
  shouldForwardProp: (0, _utils.filterProps)(_constants.textPropsToFilter)
})(function (props) {
  return props.theme.shouldUseResponsiveText ? (0, _TextCSS.responsiveTextCSS)(props) : (0, _TextCSS.textCSS)(props);
}); // shouldForwardProp is stored in this property and combined with the shouldForwardProp
// definition of any components which use styled(Text). This means that those outer
// components will be unable to use any props from Text, because they won't be forwarded
// from the outer component to the inner Text.
// To prevent this, explicitly override the property to trick emotion into thinking that
// Text doesn't use shouldForwardProp when doing styled(Text).
// This doesn't affect the Text component itself (the props won't be forwarded to the DOM).
// https://github.com/emotion-js/emotion/blob/97673098945a75b716d4cac100c1af46a5ae18f2/packages/styled-base/src/index.js#L35-L41
// eslint-disable-next-line @typescript-eslint/camelcase

TextWithoutDocs.__emotion_forwardProp = undefined;
var TextWithDocs = (0, _stencilReactDesc.describe)(TextWithoutDocs).description('Text styled to match Stencil typography rules.');
TextWithDocs.propTypes = {
  color: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'color' property for the element."),
  display: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'display' property for the element."),
  font: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'font-family' property for the element. Only supports named fonts from the theme."),
  fontSize: (0, _propTypes.cssValue)().description("Sets the CSS 'font-size' property for the element."),
  fontWeight: (0, _propTypes.cssValue)().description("Sets the CSS 'font-weight' property for the element."),
  hyphens: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'hyphens' property for the element that determines whether text should be hyphenated when it wraps."),
  lineHeight: (0, _propTypes.cssValue)().description("Sets the CSS 'line-height' property for the element."),
  textAlign: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'text-align' property for the element."),
  textDecoration: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'text-decoration' property for the element."),
  wordBreak: _stencilReactDesc.PropTypes.string.description("Sets the CSS 'word-break' property for the element that specifies how text should wrap when there isn't enough space.")
};
TextWithDocs.defaultProps = (0, _objectSpread2.default)({}, _constants.defaultProps);
var Text = (0, _utils.withTestAttributes)({
  component: 'StencilText'
})(TextWithDocs);
Text.displayName = 'Text';
var _default = Text;
exports.default = _default;